module.exports = __webpack_public_path__ + "img/03.a451f38b.png";